import React, { useEffect, useRef, useState } from "react";
import { Modal } from "../../../../Common/fModal/Modal";
import { Form2 } from "../../../../Common/Class/Form2";
import { showToast } from "../../../../Common/fToast/ToastCallback";
import { post } from "../../../../../Model/Network/Config/Axios";
import { DownloadCsv } from "../../../../../Utils/Downloader";
import Tick from '../../../../Common/fUpload/tick.png';
import { PageLoader } from "../../../../Common/Components/PageLoader";

const LineItemsSelectModal = ({
  items = [],
  close,
  details,
  tenant,
  id,
  onReload
}) => {

    const [selectedMap, setSelectedMap] = useState({});
    const [dependentmasterValueLineItem, setDependentmasterValueLineItem] = useState({});
    const [stateLoading, setStateLoading] = useState(false);
    const [error, setError] = useState([]);
    const [success, setSuccess] = useState(false);
    const [forms, setForms] = useState({});
    const CUSTOMFORM = useRef();

    const downloadErrorCsv = () => {
        const baseData = [
            ["Item ID", "Key", "Error"]
        ];
        error.forEach(item => {
            baseData.push([item.itemId, item.key, item.error]);
        });
        DownloadCsv("Error.csv", baseData);
    }

    const updateFormData = (key,value,itemId) => {
        return new Promise((resolve, reject) => {
            post(`/vendor/invoicing/${id}/change`, { key,value,itemId }, (e, r) => {
                if (r) {
                    resolve(1);
                } else if (e) {
                    resolve(0);
                    setError((prev) => [...prev, { itemId, key, error: (e && e.data && e.data.message)?e.data.message:'Unknown error' }]);
                }
            });
        })
    }

    const updateLineItemCustomForm = async () => {
      if(!Object.keys(selectedMap).length){
        showToast({
          type: 'error',
          message: 'Please select at least one line item'
        })
        return;
      }
      if(!Object.keys(forms).length){
        showToast({
          type: 'error',
          message: 'Please fill the custom forms'
        })
        return;
      }
      setStateLoading(true);
      let itemIds = Object.keys(selectedMap);
      for(let i=0;i<itemIds.length;i++){
        let itemId = itemIds[i];
        let keys=Object.keys(forms);
        for(let j=0;j<keys.length;j++){
            let key=keys[j];
            let value=forms[key];
            await updateFormData(key,value,itemId);
            await new Promise(resolve => setTimeout(resolve, 1000));
        }
      }
      setStateLoading(false);
      showToast({
        type: 'success',
        message: 'Value Updated Sucessfully'
      })
      setSuccess(true);
      onReload();
    }

    useEffect(() => {
        let dependentmasterValueLineItem={};
        if(details && details.tags && details.tags.order){
            dependentmasterValueLineItem={...dependentmasterValueLineItem,"po_id":"yes"}
        }
        else{
            dependentmasterValueLineItem={...dependentmasterValueLineItem,"po_id":"no"}
        }
        if(details && details.tags && details.tags['po.pr_iom'] && details.tags['po.pr_iom'] === 'IOM'){
            dependentmasterValueLineItem={...dependentmasterValueLineItem,"po_id":"no"}
        }
        setDependentmasterValueLineItem(dependentmasterValueLineItem);
    }, [details]);

    useEffect(() => {
        if(CUSTOMFORM.current){
            CUSTOMFORM.current.loadForm(`finance::invoice::item::${details.invoice.categoryId}`);
        }
    }, [details]);

    useEffect(() => {
        toggleAll();
    }, []);

    const toggleAll = () => {
        if (items.length === Object.keys(selectedMap).length) {
            setSelectedMap({});
        } else {
            let obj={};
            items.forEach(item => {
                obj[item.id] = true;
            });
            setSelectedMap(obj);
        }
    };

    const toggleOne = (id) => {
        let obj = {...selectedMap};
        if(id in obj) {
            delete obj[id];
        } else {
            obj[id] = true;
        }
        setSelectedMap(obj);
    }

    const renderLabel = (item) => {
        const parts = [];
        if (item && item.name) parts.push(item.name);
        if (item && item.service) parts.push(item.service);
        if (!parts.length && item && item.desc) parts.push(item.desc);
        return parts.join(" - ") || `Item #${item.id}`;
    };

    return (
      <Modal
        show={true}
        close={close}
        title={"Update Line Item Custom Forms"}
        des="Select the line items to update the custom forms"
        buttonName={success?"Close" : "Confirm"}
        modalStyle={{minWidth: "800px"}}
        stateLoading={stateLoading}
        onSave={() => {
          if(success){
            close();
          }
          else{
            updateLineItemCustomForm();
          }
        }}
      >
        {success?<>
          <div style={{ textAlign: 'center' }}>
            <img src={Tick} style={{ width: '80px', margin: '20px auto' }} alt="Tick" />
            <div style={{ fontSize: 15, fontWeight: 600, color: '#101828',marginBottom: 20 }}>Custom Forms Updated Successfully</div>
          </div>
          {
            error.length ? <div style={{display:'flex',justifyContent:'center'}}>
              <div className="btn btn-portlet"
                onClick={downloadErrorCsv}
              >
                  Download Error csv
              </div>
            </div>:null
          }
        </>:stateLoading?<div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100%'}}><PageLoader/></div>:<>
          <p style={{ fontSize: 15, fontWeight: 600, color: '#101828' }}>Select the line items to update the custom forms</p>

            <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: 12 }}>
                <p onClick={() => {
                    toggleAll()
                }} style={{
                    marginLeft: 'auto',
                    display: 'flex',
                    fontWeight: 600,
                    fontSize: 12,
                    justifyContent: 'center',
                    cursor: 'pointer',
                    color: (Object.keys(selectedMap).length === items.length)?"var(--red-color)":"var(--primary-color)",
                    alignItems: 'center'
                }}>{Object.keys(selectedMap).length === items.length ? "Deselect All" : "Select All"}</p>
            </div>
            <div style={{
              maxHeight: 360,
              overflowY: 'auto',
              border: '1px solid var(--border-color)',
              borderRadius: 8,
              padding: 8
            }}>
              {items && items.length ? items.map((item) => {
                const id = item.id;
                const checked = selectedMap[id] ? true : false;
                const label = renderLabel(item);
                return (
                  <div key={id} style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '8px 6px',
                  }}>
                    <input
                      type="checkbox"
                      id={`li_${id}`}
                      checked={checked}
                      onChange={() => toggleOne(id)}
                      style={{ marginRight: 8, cursor: 'pointer' }}
                    />
                    <label
                      htmlFor={`li_${id}`}
                      style={{
                        flex: 1,
                        cursor: 'pointer',
                        color: '#101828'
                      }}
                      title={label}
                    >
                      {label}
                    </label>
                  </div>
                );
              }) : (
                <div style={{ padding: 12, color: '#6c757d' }}>
                  No line items available.
                </div>
              )}
            </div>
            <div>
              <p style={{ fontSize: 15, fontWeight: 600, color: '#101828',margin:'20px 0px' }}>Note : For each field, please select the tick mark for updating the value.</p>
              <Form2
                  initialValues={{}}
                  dependentKeyValue={dependentmasterValueLineItem ? dependentmasterValueLineItem : {}}
                  handler={ref => CUSTOMFORM.current=ref}
                  label={`Finance Line Item Field`}
                  updateForm={(key, value) => {
                    setForms((prev) => ({...prev, [key]: value}));
                  }}
                  tenant={tenant}
                  categoryId={(details && details.invoice && details.invoice.categoryId) ? details.invoice.categoryId : null}
                />
            </div>
        </>}

      </Modal>
    );
};

export default LineItemsSelectModal;


